import React, {useEffect, useState} from 'react'
import Sidebar from "../../components/sidebar/Sidebar";

import {useLocation, useNavigate, useSearchParams} from "react-router-dom";

import {useDispatch, useSelector} from "react-redux";
import LoadingTable from "../../components/LoadingTable";
import {getMonitorKelas,resetTable,updateStateMonitorKelas} from "../../features/monitorKelasSlice";
import Search from "../../components/Search";
import searchIcon from "../../assets/icons/search-icon.svg";
import Profile from "../../components/Profile";

import TidakValid from '../../assets/icons/Stat Icon.svg'
import Kosong from '../../assets/icons/Stat Icon-1.svg'
import Valid from '../../assets/icons/Stat Icon-2.svg'
import BelumValid from '../../assets/icons/Stat Icon-3.svg'

const PRIMARY = '#3661EB'
const GREY = '#9B9B9B'
const BORDER = '#ECEEF2'

const badgeConfig = {
  Valid: { bg: '#EBF6EF', border: '#B8E1C4', color: '#289B5D', dot: '#289B5D' },
  Kosong: { bg: '#FFFBEB', border: '#E1D6B8', color: '#F59E0B', dot: '#F59E0B' },
  'Belum Divalidasi': { bg: '#F1F5F9', border: '#CBD5E1', color: '#64748B', dot: '#94A3B8' },
  'Tidak Valid': { bg: '#F5D3D3', border: '#EA7777', color: '#EF4444', dot: '#EF4444' },
}

function DashboardKelas() {
    const {
        isLoading,
        listMonitorKelas,
        search
    } = useSelector(state => state.monitorKelasSlice)

    const dispatch = useDispatch()
    const location = useLocation()
    const navigate = useNavigate()
    const [searchParams, setSearchParams] = useSearchParams()

    useEffect(() => {
        dispatch(resetTable())
    }, []);

    useEffect(() => {
        dispatch(getMonitorKelas({}))
    }, []);

    useEffect(() => {
        if (searchParams.get('paginate')) {
            dispatch(updateStateMonitorKelas({name: 'currentPage', value: parseInt(searchParams.get('paginate'))}));
        }
    }, [location.pathname, navigate, searchParams]);

    useEffect(() => {
        if (searchParams.get('search')) {
            dispatch(updateStateMonitorKelas({name: 'search', value: searchParams.get('search')}));
            dispatch(getMonitorKelas({search: searchParams.get('search')}))
        }
    }, [])

    useEffect(() => {
        dispatch(updateStateMonitorKelas({name: 'currentPage', value: 1}))
    }, [location.pathname.split('/').pop()]);

    function handleSearch() {
        dispatch(getMonitorKelas({search}))
        dispatch(updateStateMonitorKelas({name: 'currentPage', value: 1}))
        setSearchParams({ 'search': search })
    }

    function handleKeyDown(e) {
        if (e.key === 'Enter') handleSearch();
    }

    const statCards = !isLoading ? [
        { label: 'Kosong',      icon: BelumValid,     value: listMonitorKelas.data.kosong },
        { label: 'Valid',       icon: Valid,       value: listMonitorKelas.data.valid },
        { label: 'Tidak Valid', icon: TidakValid,  value: listMonitorKelas.data.tidak_valid },
        { label: 'Belum Divalidasi', icon: Kosong,  value: listMonitorKelas.data.belum_valid },



    ] : []

    return (
        <div className='wrapper-karyawan'>
            <Sidebar/>
            <div className='karyawan'>

                <div className='search-and-profile'>
                    <div className='wrap-search'></div>
                    <Profile/>
                </div>

                {!isLoading && (
                    <div style={{ display: 'flex', marginBottom: 32, justifyContent: 'space-between' }}>
                        {statCards.map((stat, i) => (
                            <StatCard key={i} {...stat} />
                        ))}
                    </div>
                )}

                <div className='title-btn'>
                    <h1>Monitor Kelas</h1>
                    <div style={{ display: 'flex', justifyContent: 'end', alignItems: 'center', gap: '10px', width: 500 }}>
                        <div style={{
                            display: 'flex', alignItems: 'center', gap: 12,
                            background: '#fff', border: `1px solid ${BORDER}`,
                            borderRadius: 10, padding: '0 16px', height: 48, width: 300,
                        }}>

                            <input
                                type="text"
                                placeholder="Cari Kelas"
                                name="search"
                                value={search}
                                onKeyDown={handleKeyDown}
                                onChange={(e) => dispatch(updateStateMonitorKelas({name: 'search', value: e.target.value}))}
                                style={{ border: 'none', outline: 'none', fontSize: 14, color: '#A6A6A6', flex: 1 }}
                            />
                        </div>
                        <button
                            className='btn-search'
                            style={{ background: '#fff', border: `1px solid ${BORDER}`, borderRadius: 10, padding: '0 16px', height: 48, width: 48 }}
                            onClick={handleSearch}
                        >
                            <img src={searchIcon} alt=""/>
                        </button>
                    </div>
                </div>

                {isLoading
                    ? <LoadingTable size={'large'}/>
                    : <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 385px)', justifyContent: 'space-between' }}>
                        {listMonitorKelas.monitorkelas.map((card, i) => (
                            <JournalCard key={i} card={card} />
                        ))}
                    </div>
                }

            </div>
        </div>
    )
}

function StatCard({ label, icon, value }) {
    return (
        <div style={{
            background: '#fff', borderRadius: 14,
            border: `1px solid ${BORDER}`,
            width: 285, height: 88, overflow: 'hidden', flexShrink: 0,
            display: 'flex', alignItems: 'stretch',
        }}>
            {/* Left accent bar */}


            {/* Icon + text */}
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '0 16px' }}>
                <div style={{
                    width: 44, height: 44, borderRadius: 10, background: '#EFF6FF',
                    display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                }}>
                    <img src={icon} width={24} alt="" />
                </div>
                <div>
                    <p style={{ margin: 0, fontSize: 14, color: '#64748B', fontWeight: 500 }}>{label}</p>
                    <p style={{ margin: '4px 0 0', fontSize: 22, color: PRIMARY, fontWeight: 700 }}>{value}</p>
                </div>
            </div>
        </div>
    )
}

function Badge({ status }) {
    const cfg = badgeConfig[status]
    return (
        <div style={{
            display: 'flex', alignItems: 'center', gap: 5,
            background: cfg.bg, border: `1px solid ${cfg.border}`,
            borderRadius: 11, padding: '3px 10px', height: 22, flexShrink: 0,
        }}>
            <div style={{ width: 6, height: 6, borderRadius: '50%', background: cfg.dot, flexShrink: 0 }} />
            <span style={{ fontSize: 10, fontWeight: 600, color: cfg.color, whiteSpace: 'nowrap' }}>{status}</span>
        </div>
    )
}

function JournalCard({ card }) {
    return (
        <div style={{
            background: '#fff', borderRadius: 14, marginBottom: 15,
        overflow: 'hidden', flexShrink: 0,
            border: `1px solid ${BORDER}`,
            display: 'flex', flexDirection: 'column',
        }}>
            {/* Header */}
            <div style={{
                background: '#EEF2FE', padding: '16px',

                display: 'flex', alignItems: 'center', gap: 10,
            }}>
                <div style={{
                    width: 36, height: 36, borderRadius: 12, background: '#D1DBFB',
                    display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                }}>
                    <span style={{ fontSize: 16, fontWeight: 700, color: PRIMARY }}>M</span>
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                    <p style={{ margin: 0, fontSize: 14, fontWeight: 600, color: '#223261', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {card.kelas}
                    </p>
                    <p style={{ margin: 0, fontSize: 11, color: '#6B7DA3', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {card.jam_masuk}
                    </p>
                </div>
                <Badge status={card.status} />
            </div>

            {/* Divider */}
            <div style={{ height: 1, background: '#F1F5F9' }} />

            {/* Body */}
            <div style={{ padding: '12px 20px' }}>
                <p style={{ margin: 0, fontSize: 12, fontWeight: 500, color: '#334156' }}>{card.guru}</p>
                <p style={{ margin: '4px 0 0', fontSize: 11, color: '#64748B' }}>{card.mapel}</p>
            </div>

            {/* Separator */}
            <div style={{ height: 1, background: '#F1F5F9', margin: '0 20px' }} />

            {/* Footer */}
            <div style={{ padding: '10px 20px', display: 'flex', alignItems: 'center', gap: 8 }}>
                <div style={{ width: 6, height: 6, borderRadius: '50%', background: '#1584c1', flexShrink: 0 }} />
                <p style={{ margin: 0, fontSize: 10, color: '#64748B' }}>{card.total_siswa_hadir}</p>
            </div>
        </div>
    )
}

export default DashboardKelas
